<template>
  <div class="prevent-swindle">
    <h2>诈骗防范小知识</h2>
    <p class="text"> 诈骗是以虚构的事实或隐瞒事实真相的欺骗方法，骗取公私财物。犯罪分子利用他人贪图小便宜，急于发大财，相信封建迷信、富有同情心和关注自身身体健康的特点，采取各种手段诱使人们上当受骗。近年来，随着国际互联网、通信网络的发展，是使日常生活越来越便利的同时，也给不法分子利用现代通讯技术实施诈骗等犯罪活动提供了可乘之机。</p>
    <p class="title">诈骗案例及手段分析</p>
    <p class="three-title">案例一：邮包诈骗</p>
    <p class="text">特点：冒充邮政、快递公司打电话，称对方名下包裹夹带违禁物品，涉嫌贩毒、洗钱犯罪等，以配合调查为由，要求其向“安全账户”转账。</p>
    <p class="text">案例：去年2月16日，义乌人陈先生接到一广东口音女子电话，自称邮局工作人员，说在他邮寄包裹内发现毒品，需联系公安机关协助调查。陈先生根据对方提示，联系上一名自称是禁毒大队的男子，男子说为保全陈先生银行卡里的钱，需把钱存入指定账户，12小时后返还，陈先生汇完40000元后，再也联系不上对方。</p>
    <img src="@/assets/articleImg/211.png" alt="" class="img-item">
    <p class="three-title">案例二：冒充领导</p>
    <p class="text">特点：假冒领导、秘书或某部门工作人员打电话给基层单位员工，让对方或单位预付订购款、配套费、手续费等。由于“领导”能准确说出你的身份，不少人上当。</p>
    <p class="text">案例：去年8月29日傍晚，义乌某事业单位的张女士，突然接到“领导”电话，让她明天去下办公室。她问“是哪位领导？”对方霸气地回答“我是谁你都不知道，你领导有几个，好好想想”。因为对方能叫出自己名字和工作岗位，张女士信以为真。“领导”说他在外面陪客户吃饭，钱不够，需要转账，回头让单位给张女士报销，张质疑后，领导还在电话里怒吼，张马上跟单位核实，才知遇到了骗子。</p>
    <img src="@/assets/articleImg/212.png" alt="" class="img-item">
    <p class="three-title">案例三：通知“退费”</p>
    <p class="text">特点：冒充税务、银行等部门工作人员，以退款、退税为由，要求你在ATM机上按指令做实为转账的操作，将卡内的钱转走。</p>
    <p class="text">案例：去年2月初，刚从金华某高中毕业的小陈接到电话，对方自称教育局工作人员，说因政策调整，可以退还学费1980元，需到ATM机上查收。小陈按对方要求到ATM机上操作转账，结果账上余额全部被转走。</p>
    <img src="@/assets/articleImg/213.png" alt="" class="img-item">
    <p class="three-title">案例四：相亲“借”手机</p>
    <p class="text">特点：网上相亲认识女子，网聊感觉不错，见面后相谈甚欢，女子提出手机没电借手机打电话，随后顺走手机。</p>
    <p class="text">案例：去年正月初三，某相亲网上，有陌生女孩主动加了金华的小邓，两人聊得很投机，2月6日两人相约见面，聊了会，小邓去上厕所，回来后，女孩不见了，桌上手机也不见了，通过监控，小邓发现自己离开座位后，女孩拿走手机。他上网联系对方时，账号已被删除。警方提醒：遇到陌生人借手机一定多留个心眼，不能让手机离开视线。</p>
    <img src="@/assets/articleImg/214.png" alt="" class="img-item">
    <p class="three-title">案例五：机票“改签”</p>
    <p class="text">特点：在航班起飞前一天收到短信：因飞机机械故障不能正常起飞，请及时与我公司客服联系办理退票或改签。拨打对方电话，对方指导你通过ATM机转账20元改签费，再输入一定数字的“验证码”，卡上钱被转走。</p>
    <p class="text">案例：去年10月，永康的胡女士和同事准备去北京，订好机票的第二天上午，胡女士接到短信说航班取消，改签需20元改签费，航空公司赔偿200元误机费。按照“客服”提示，胡女士在ATM机上输入所谓代码，结果卡内钱被转走。</p>
    <img src="@/assets/articleImg/215.png" alt="" class="img-item">
    <p class="three-title">案例六：山寨逮捕证</p>
    <p class="text">特点：打电话给你：“你因为涉嫌洗钱罪被警方批捕，如果不想被带走，汇10万元做保证金。”之后还会收到逮捕通知书等。</p>
    <p class="text">案例：市民王女士接到这样一个电话，又在邮箱中收到电子版逮捕通知书，上面有自己照片、身份证，还加盖了公安局、法院公章。王女士吓坏了，赶忙往对方指定账户汇去10万元，之后向警方核实，才知是骗局。</p>
    <img src="@/assets/articleImg/216.png" alt="" class="img-item">
    <p class="three-title">案例七：求微信验证码</p>
    <p class="text">特点：微信收到“新朋友”添加请求，对方声称加好友要输验证码，让你将手机收到的验证码转发，照做后，银行钱被转走。其实，你发的是支付宝付款验证码，骗子先盗取支付宝账号，又骗走验证信息，转走银行卡上的钱。</p>
    <p class="text">案例：小刘发现微信推出电话本后，进行了更新，当天下午就收到“新朋友”的添加请求，对方称加好友要输入验证码，小刘照做。结果收到银行短信，卡上少了2万元。</p>
    <img src="@/assets/articleImg/217.png" alt="" class="img-item">
    <p class="three-title">案例八：“熟人”借钱</p>
    <p class="text">特点：冒充受害人亲友，或以“猜猜我是谁”的方式，以“住院急需用钱”等理由骗取钱财。</p>
    <p class="text">案例：去年2月27日，义乌人邹先生接到陌生男子电话，让他猜猜自己是谁，邹先生听声音像一个朋友，就问对方是不是，对方夸邹先生听力好，随后说自己去夜总会喝酒被公安扫黄抓到，要交5000元保证金才能释放。因为和这位朋友关系不错，第二天邹先生向对方账号汇了5000元，对方又说要把跟自己一起的四个朋友都保出来，还要借2万元，邹才发觉被骗。</p>
    <img src="@/assets/articleImg/218.png" alt="" class="img-item">
    <p class="three-title">案例九：10086短信诈骗</p>
    <p class="text">特点：收到“10086”发来短信：您的积分已到账，请登录移动商城“10086.ydcx2.pw”兑换N元现金，按提示激活领取，根据提示，输入姓名、身份证号、银行卡号、密码及银行卡捆绑手机号后，卡内钱就会被转走。</p>
    <p class="text">案例：去年12月22日，义乌发生19起类似案件。当天下午3点，受害人刘先生接到短信后，把自己银行卡卡号及密码发过去，随后收到验证码，他按提示输入验证码后，卡里少了5000元。</p>
    <p class="text">警方提醒：骗子是用改号软件冒充了10086。</p>
    <img src="@/assets/articleImg/219.png" alt="" class="img-item">
    <p class="title">如何加强自我防范意识</p>
    <p class="text">一、要有反诈骗意识,俗话说害人之心不可无有,防人之心不可无, 对于陌生人不可随意轻信和盲目随从, 不要因为对方说了什么许诺了什么好处就轻信盲从。</p>
    <p class="text">二、切忌贪小便宜,对飞来的横财和好处特别是不熟悉的人所需诺的利益要深思和调查,要知道天上不会掉馅饼，克服贪小便宜的心理，要三思而后行。</p>
    <p class="text"> 三、破除封建迷信,不要相信什么神医之类的谎言,如果素不相识的人清楚你的家庭情况或其他情况,更要引起你的警觉, 钱财不出手,把住这一点,你就不会掉入陷阱。</p>
    <p class="text">四、必须冷静,千万不要慌张,一旦发现被骗,赶快想办法及时掌握对方的有罪证据,迅速报警,要防止打草惊蛇, 聪明的做法是,一方面装做仍闷在鼓里,随时掌握对方行踪,一方面查明对方骗财的流向及时报案。</p>
    <p class="title">温馨提示</p>
    <p class="text">诈骗犯罪,是指以虚构事实或者隐瞒真象的欺骗方法,骗取数额较大的公私财物的行为。其突出特点就是使用欺骗的方法取得公私财物。在犯罪形式上,犯罪分子多以编造假情况或隐瞒事实真象,而使受害者陷于一种错误认识,信以为真,仿佛“自愿地”将财物交与犯罪人,但实际上,这只是受害人被犯罪分子制造的假象所迷惑而受骗上当的结果,并非真正同意。当前,诈骗活动形式多样,作案手段不断翻新。为了让广大群众提高防范能力,防止上当受骗，温馨提示:小利便宜切莫贪,别人下套你别钻;相信科学弃封建,一切都按规矩办;遇见讹诈你别怕,冷静应对快报案。</p>
  </div>
</template>
<script>
export default {
  data () {
    return {

    }
  }
}
</script>
<style lang="less" scoped>
p {
  margin: 0;
}
h2 {
  margin: 0;
  padding-bottom: 38.4px;
  margin: 0;
  font-size: 57.6px;
  font-weight: 700;
}
.prevent-swindle {
  padding: 48px;
  color: #000;
  .text {
    font-size: 40px;
    line-height: 1.6em;
    text-indent: 1em;
    color: inherit;
    font-weight: 400;
    text-align: justify;
    white-space: normal;
  }
  .title{
    color: rgb(237, 35, 8);
    text-align: center;
    font-size: 40px;
    line-height: 1.6em;
    font-weight: 700;
    padding: 20px;
  }
  .three-title {
    font-size: 40px;
    line-height: 1.6em;
    font-weight: 400;
    padding: 20px;
  }
  .img-item{
    width: 100%;
    margin: 51.2px 0;
  }
}
</style>
